import makeStyles from "@material-ui/core/styles/makeStyles";
import { COLORS } from "../../../../constants";

export const usePrivateClassCardStyles = makeStyles(() => ({
  root: {
    width: 732,
    minHeight: 239,
    background: "#FFFFFF",
    boxShadow: "0px 0px 8px #C2C9D682",
    borderRadius: 15,
    "& + &": {
      marginTop: 24,
    },
  },
  header: {
    height: 90,
    borderBottom: "1px solid #DBDBDB;",
    display: "flex",
    padding: "15px 15px",
  },
  content: {
    minHeight: 109,
    borderBottom: "1px solid #DBDBDB;",
    padding: "5px 5px",
    display: "grid",
    gridColumnGap: 2,
    gridRowGap: 6,
    gridTemplateColumns: "1fr",
    "& > div": {
      minHeight: 60,
    },
  },
  bioField: {
    maxWidth: "none !important" as any,
    width: "100%",
    gridTemplateColumns: "32px 1fr !important" as any,
    "& > div": {
      maxWidth: "none !important" as any,
      width: "100%",
    },
    '& [class*="previewContainer"]': {
      height: "36px !important",
    },
  },
  footer: {
    height: 40,
    padding: "15px 15px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  teacherImage: {
    width: 60,
    height: 60,
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  },
  headerInfoContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  headerInfoSubContainer1: {
    marginRight: 14,
    marginLeft: 15,
    maxWidth: 356,
  },
  teacherName: {
    fontSize: 15,
    fontWeight: "bold",
    color: "#231F20",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    lineHeight: 1.1,
  },
  grade: {
    marginLeft: 16,
    fontWeight: "bold",
  },
  bold: {
    fontWeight: "bold",
  },
  smallText: {
    fontSize: 10,
    color: "#4B4B4B",
  },
  teachingLanguage: {
    fontSize: 14,
    color: "#4B4B4B",
    marginTop: 3,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  headerInfoSubContainer2: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  },
  subjectName: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#231F20",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  addressContainer: {
    display: "flex",
    alignItems: "center",
  },
  locationIcon: {
    marginRight: 12,
    marginTop: -4,
  },
  arrowRight: {
    paddingTop: "unset",
  },
  address: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#231F20",
    maxWidth: 530,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  link: {
    display: "flex",
    fontSize: 14,
    fontWeight: "bold",
    color: "#957F2F",
    "&:hover": {
      textDecoration: "none",
      color: "#AA933F",
    },
  },
}));
